import { ref, get } from "firebase/database";
import { database } from "../../../Utils/firebase";

const GetUserDataFirebase = async (userId) => {
    if (!userId) return null;

    try {

        const userRef = ref(database, `invoiceGenerator/users/${userId}/user`);
        const snapshot = await get(userRef);
        const userData = snapshot.val();

        return userData;


    } catch (error) {
        console.error("Error fetching user data:", error);
        return null;
    }
};

export default GetUserDataFirebase;
